import { get } from "lodash";


const styles = (theme) => ({
  content: {
    margin: 36,
    minHeight: 'calc(100vh - 125px)',
    backgroundColor: get(theme, 'color.uiBackground'),
    marginTop: 0,
    padding: '24px 0px 36px 0px',
    '& button': {
      '&:focus': {
        outlineWidth: '1px !important',
        outlineOffset: '1px !important',
      },
    },
  },
  fieldContainer: {
    width: 590,
    marginTop: "5px !important",
  },
  gridContainer: {
    display: 'inline-flex',
    width: '100%',
    paddingLeft: 36,
  },
  divider: {
    backgroundColor: get(theme, 'color.bodyText'),
  },
  bodyContent: {
    display: 'block',
  },
  contentPadding: {
    padding: '0px 36px',
  },
  flexNonBetween: {
    display: 'flex',
    alignItems: 'center',
  },
  flex: {
    display: 'flex',
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexNonAlign: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  detailsHeading: {
    textTransform: 'capitalize',
    marginTop: '3rem',
  },
  apiPlansDescription: {
    width: 630,
  },
  deleteButton: {
    color: get(theme, 'color.error'),
    borderColor: get(theme, 'color.error'),
  },
  textError: {
    color: get(theme, 'color.error'),
  },
  keyLimit: {
    textTransform: 'capitalize',
    marginBottom: 8,
  },
  keyLimitDesc: {
    marginBottom: 15,
  },
  quotaField: {
    width: 350,
  },
  quotaDuration: {
    marginTop: '12px !important',
    marginLeft: 10,
  },
  quotaContainer: {
    marginTop: "-1rem",
  },
  rateLimitField: {
    marginTop: "10px !important",
  },
  rateLimitQuotasContainer: {
    marginLeft: "3rem",
  },
  overViewFieldsContainer: {
    width: 600,
    marginLeft: 30,
  },
  rateLimitContainer: {
    marginTop: "0px !important",
  },
  overViewTabContent: {
    padding: "0px 36px !important",
    flexWrap: "wrap",
  },
  editIconButton: {
    fill: get(theme, 'color.primaryButtonBackground'),
    minWidth: 0,
    width: 35,
    height: 35,
    padding: 0,
    marginLeft: "1rem",
    marginTop: "1rem",
  },
  apiPlanName: {
    wordWrap: 'break-word',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '90%',
  },
  apiPlanNameContainer: {
    width: "40%",
  },
  nameContainer: {
    marginTop: -13,
  },
  alertMessagesContainer: {
    marginLeft: 0,
    width: "93% !important",
  },
  rateLimitQuotaLabel: {
    fontWeight: "bold",
  },
})

export default styles;